import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const PractitionerIcon = ({ size = "md", ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.84 16.26C17.86 16.83 20 18.29 20 20V22H4V20C4 18.29 6.14 16.83 9.16 16.26L12 21L14.84 16.26ZM8 8.00001H16V10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10V8.00001ZM8 7.00001L8.41 2.90001C8.43487 2.65249 8.55111 2.42312 8.73602 2.25671C8.92093 2.09029 9.16123 1.99877 9.41 2.00001H14.6C15.11 2.00001 15.54 2.39001 15.59 2.90001L16 7.00001H8ZM12 3.00001H11V4.00001H10V5.00001H11V6.00001H12V5.00001H13V4.00001H12V3.00001Z",
      fill: rest.fill
    }
  ) });
};
export {
  PractitionerIcon
};
